import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";
import apiPath from "../../shared/apiPath";

const content_type = "";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const fields = [
  {
    key: "notify_type",
    label: "类型",
    type: "button",
    button: {
      type: "text"
    },
    thStyle: { width: "80px" }
    // isRowHeader:true,
  },
  {
    key: "name",
    label: "名称",
    sortable: true
  },
  // {
  //   key: "notify_type",
  //   label: "类型",
  //   sortable: true
  // },
  {
    key: "description",
    label: "说明",
    sortable: true
  }
];
const fields2 = [
  {
    key: "id",
    label: "编号",
    sortable: true,
    thStyle: { width: "60px" }
  },
  {
    key: "username",
    label: "用户名",
    sortable: true
  },
  {
    key: "realname",
    label: "真实姓名",
    sortable: true
  },
  {
    key: "is_valid",
    label: "启用",
    type: "boolean"
  }
];

const dataForm = {
  notify_type: "",
  name: "",
  description: ""
};

///前端验证
const rules = {
  // notify_type: [{
  //   required: true,
  //   message: "请输入类型",
  //   trigger: "blur"
  // }],
  // name: [{
  //   required: true,
  //   message: "请输入名称",
  //   trigger: "change"
  // }],
  // description: [{
  //   max: 500,
  //   message: "超过描述长度",
  //   trigger: "blur"
  // }]
};

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res);
            } else {
              reject("测试没通过");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
const methods = {
  async getUserData() {
    let result = await api.query_async({
      url: apiPath.admin.get_user_list,
      parameters: null,
      method: "get"
    });
    ///此处可以编写逻辑处理
    if (
      result &&
      result[0].result.data &&
      result[0].result.data.Result.length > 0
    ) {
      return result[0].result.data.Result;
    } else {
      return null;
    }
  },
  //获取角色
  async GetNotifyTypes() {
    let data = await api.query_async({
      url: apiPath.admin.get_notify_types,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  },
  //新增或修改notify
  async addAndUpdate(_data, _bool) {
    let _p = new FormData();
    let data = null;
    //_bool true 新增 false update

    _p.append("notifyType", _data.notify_type);
    _p.append("name", _data.name);
    _p.append("description", _data.description);
    if (_bool) {
      data = await api.query_async({
        url: apiPath.admin.add_notify_type,
        parameters: _p,
        method: "post"
      });
    } else {
      data = await api.query_async({
        url: apiPath.admin.update_notify_type,
        parameters: _p,
        method: "post"
      });
    }

    if (data) {
      return {
        success: data[0].result.data.Success,
        id: data[0].result.data.Result
      };
    }
    return {
      success: false,
      id: 0
    };
  },
  //新增或删除通知--用户
  async AddORDeleteNotifyUsers(notify_type, hasData, newData) {
    //如果hasData中不包含newData中的权限即为新增
    let _add = [],
      _del = [];
    for (var i in newData) {
      if (
        _.findIndex(hasData, {
          user_id: newData[i].id
        }) < 0
      ) {
        _add.push(newData[i]);
      }
    }
    //如果newData中不包含hasData的权限即为删除
    for (var i in hasData) {
      if (
        _.findIndex(newData, {
          id: hasData[i].user_Id
        }) < 0
      ) {
        _del.push(hasData[i]);
      }
    }
    let query_settings = [];
    for (var i in _add) {
      let _p = new FormData();
      _p.append("notifyType", notify_type);
      _p.append("specUserId", _add[i].id);
      query_settings.push({
        url: apiPath.admin.add_notify_users,
        parameters: _p,
        method: "post"
      });
    }
    for (var i in _del) {
      let _p = new FormData();
      _p.append("notifyType", notify_type);
      _p.append("specUserId", _del[i].user_Id);
      query_settings.push({
        url: apiPath.admin.remove_notify_user,
        parameters: _p,
        method: "post"
      });
    }
    let data = await api.query_all_async(query_settings);
    if (data) {
      return data[0].result.data.Success;
    } else {
      return false;
    }
  },
  //更改notify状态
  async UpdateNotify(_data) {
    let is_deleted = false;
    let datas = _data.selected_items;
    // console.log(datas)
    switch (_data.state) {
      case "deleted":
        //删除
        is_deleted = true;
        break;
      default:
        break;
    }
    let query_settings = [];

    if (!is_deleted) {
      // 修改操作
    } else {
      // 删除操作
      for (var i in datas) {
        let _p = new FormData();
        _p.append("notifyType", datas[i].notify_type);
        query_settings.push({
          url: apiPath.admin.remove_notify_type,
          parameters: _p,
          method: "post"
        });
      }
      let data = await api.query_all_async(query_settings);
      if (data) {
        return data[0].result.data.Success;
      } else {
        return false;
      }
    }
  },
  //获取权限
  async GetNotifyUsers(notify_type) {
    let data = await api.query_async({
      url: apiPath.admin.get_notify_users,
      parameters: { notifyType: notify_type },
      method: "get"
    });
    if (data && data[0] && data[0].result) {
      return data[0].result.data.Result;
    }
    return null;
  },
  async GetRoleOwnPrivilege(roleId) {
    let data = await api.query_async({
      url: apiPath.admin.get_role_own_privilege_list + roleId,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  }
};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
// export * from "../../shared/biz_data_helper"
export { fields, fields2, dataForm, rules, biz_data, methods };
